import useStyles from "isomorphic-style-loader/useStyles";
import React, { useEffect } from "react";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useSelector, useStore } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Header from "../../../../components/header";
import { Iconfont } from "../../../../components/icon/iconfont";
import classes from './style.module.scss';
import { SearchBar } from "../../components/search-bar";
import { action_fetch_ticket_questions_tree } from "../../../../../store/actions/pages/customer";

const DropDownItem = props => {
    useStyles(classes)
    const {iconImg, title, questionList, open, clickItem} = props
    const [showMore, setShowMore] = useState(false);

    useEffect(()=>{
        if(open){
            setShowMore(true)
        }
    },[open])

    return (
        <div className={classes.DropDownPositionBox}>
            <div className={classes.DropDownItem1} onClick={()=>setShowMore(!showMore)}>
                <Iconfont className={classes.DropDownIcon} dangerouslySetInnerHTML={{__html:iconImg}}></Iconfont>
                <div className={classes.DropDownTxt}>{title}</div>
                {
                    showMore ?
                    <Iconfont className={classes.DropDownShow}>&#xe77f;</Iconfont> :
                    <Iconfont className={classes.DropDownShow}>&#xe77e;</Iconfont>
                }
            </div>
            {
                (showMore && questionList && questionList.length > 0) &&
                <div className={classes.MoreQuestion}>
                    {
                        questionList.map((item, index) => {
                            return <span key={index} onClick={()=>clickItem(item)}>{item?.question}</span>
                        })
                    }
                </div>
            }
        </div>
    )
}

const DropDownList = props => {
    useStyles(classes)
    const {dropDownList, clickItem} = props
    return(
        <div className={classes.DropDownList}>
            {
                dropDownList?.map((item, index) => {
                    return <DropDownItem
                                iconImg={item?.icon}
                                title={item?.question}
                                questionList={item?.children}
                                open={item?.open}
                                clickItem={(e)=>clickItem(e)}
                                key={index}>
                            </DropDownItem>
                })
            }
        </div>
    )
}

const Questions = props => {
    useStyles(classes)
    const Intl = useIntl()
    const history = useHistory()
    const location = useLocation()
    const [defaultShow, setDefaultShow] = useState(true)
    const store = useStore()
    const { ticketQuestionsTree } = useSelector(state => state.pageCustomer);

    const [dropDownList, setDropDownList] = useState([])

    useEffect(async () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
        // document.body.style.background = "#fff"
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
            if(!ticketQuestionsTree){
                await Questions.fetchData(store, null, null)
            }
		}
        return (() => {
            // document.body.style.background = ''
        })
    }, [])

    useEffect(() => {
        if(ticketQuestionsTree){
            let openTitle = location?.params?.title
            let list = ticketQuestionsTree.map((item) => {
                if(item?.question == openTitle){
                    return {...item, open:true}
                } else {
                    return {...item, open:false}
                }
            })
            setDropDownList(list)
        }
    }, [ticketQuestionsTree])

    const search = (e) => {
        if(e){
            history.push({pathname: `/user/support/question`, state:{search: e, parentId: e.parentId, fromFAQ:true}})
        }
    }

    const clickItem = (e) => {
        // console.log("item:",e);
        history.push({pathname:`/user/support/question`, state:{id:e.id, parentId: e.parentId, fromFAQ:true}})
    }

    return (
        <div className={classes.QuestionsPage}>
            <Header centerSlot={Intl.formatMessage({ id: "faq", defaultMessage: "FAQ" })}/>
            <div className={classes.SearchBarBox}>
                {
                    defaultShow &&
                    <div className={classes.HowTxt}>
                        {Intl.formatMessage({id:"help_you", defaultMessage:"How Can I Help You?"})}
                    </div>
                }
                <SearchBar search={(e)=>search(e)} intl={Intl} questions={ticketQuestionsTree} history={history}></SearchBar>
            </div>

            {
                defaultShow &&
                <DropDownList clickItem={clickItem} dropDownList={dropDownList}/>
            }
        </div>
    )
}

Questions.fetchData = async (store, params, search, headers) => {
    const getQuestions = store.dispatch(action_fetch_ticket_questions_tree(headers))
    return await Promise.all([getQuestions])
}

export default Questions